import React from "react";
import Heading from "../../../components/Heading";
import PropTypes from "prop-types";
import Link, { navigateTo } from "gatsby-link";
import "../../../css/productdetail.css";
import { Button } from "react-bootstrap";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
import "../../../components/slick.css";
import "../../../components/slick-theme.css";
import {
  SpiceDetails,
  DhoopDetails,
  Misc,
  recipes,
} from "../../../Constants/productListConstant";
import { connect } from "react-redux";
import ContentPage from "../../../components/content-page";
import Meta from "../../../components/meta";
import RestrictedStateWiseComponent from "../../../components/RestrictedStateWiseComponent";
// import CommentSection from "../../../components/CommentSection"

// ReactPixel.track("AddToCart", {})
export class DetailView extends React.Component {
  constructor(args) {
    super(args);
    // const { content } = this.props
    this.state = {
      showDropdown: false,
      qty: 0,
      added: false,
      content: {},
    };
    this.type = "";
  }
  componentWillMount() {
    // console.log("w", window.location)
  }
  componentDidMount() {
    let { contentPromise } = this.props;
    ReactPixel.init("145006083100066");
    contentPromise.then((item) => {
      // console.log("item", item)
      if (!item.productName) {
        navigateTo(`/store`);
      } else {
        this.setState({
          qty: item.qty || 0,
          added: item.qty > 0,
          content: item,
        });
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    const { contentPromise } = nextProps;
    if (nextProps.isAddToCartChange !== this.props.isAddToCartChange) {
      contentPromise.then((item) => {
        // console.log("item", item)
        if (!item.productName) {
          navigateTo(`/store`);
        } else {
          this.setState({
            qty: item.qty || 0,
            added: item.qty > 0,
            content: item,
          });
        }
      });
    }
  }
  componentWillUnmout() {}
  onChangeRecipe = () => {
    this.setState({
      showDropdown: !this.state.showDropdown,
    });
  };
  handleQuantity = (fn) => {
    let { qty } = this.state;
    if (fn === "add") {
      this.setState({
        qty: qty + 1,
        added: false,
      });
    } else {
      if (qty - 1 > 0) {
        this.setState({
          qty: qty - 1,
          added: false,
        });
      }
    }
  };
  addToCart = () => {
    const { setToCart } = this.props;
    const { qty, content } = this.state;
    if (qty <= 0) {
      return;
    }
    // window.localStorage.setItem("cart", {})
    let cart = JSON.parse(localStorage.getItem("cart"));
    let addedProduct = {
      ...content,
      qty: qty,
    };
    if (!cart) {
      cart = {
        products: {},
        totalNumber: 0,
      };
    }
    let totalNumber = 1;
    let bucket = {
      products: {
        ...cart.products,
        [addedProduct.id]: addedProduct,
      },
      totalNumber: totalNumber,
    };
    ReactPixel.track("AddToCart", bucket);
    // Object.keys(cart.products).map((key) => {
    // 	totalNumber = totalNumber + cart.products[key].qty
    // })
    // let bucket = cart ? (cart.products || {}) : {}
    this.setState({
      added: true,
    });
    // console.log("content", content, cart, bucket)
    // return
    localStorage.setItem("cart", JSON.stringify(bucket));
    setToCart(bucket);
    // var retrievedObject = localStorage.getItem("cart")
  };
  render() {
    const { header1, location, region } = this.props;
    const { showDropdown, qty, added, content } = this.state;
    let searchString = (location.search.split("?")[1] || "").split("&");
    // const type = searchString[0] || null
    // const title = searchString[1] || null
    // console.log("header1", title)
    let settingsForDesktop = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
    };
    let settingsPanel2 = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 2,
    };
    let settings2 = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    let sliderList = [];
    let redirectTo = "";
    if (header1 === "Spices") {
      sliderList = [...Misc, ...SpiceDetails];
      redirectTo = "?all_spices";
    } else if (header1 === "Dhoop") {
      sliderList = DhoopDetails;
      redirectTo = "?puja_materials";
    } else {
      sliderList = [...Misc, ...SpiceDetails];
      redirectTo = "?misc";
    }
    // content = {}
    return (
      <ContentPage>
        <Meta
          title={`${content.productName ||
            "Bawa Masala Company About Products | Fragrant, Flavourful, Fresh Spices"}`}
          image={content.imgUrls}
          description={
            content.desc ||
            "Enquire about bulk or dealer orders."
          }
          location={location}
        />
        {content.productName ? (
          <div className="global__wrapper">
            <div className="product__detail__wrapper">
              <Heading title={header1} />
              <div className="item__content">
                <div className="nav__bar">
                  <Link to={`/products`}>
                    <span className="active">Product Range</span>
                  </Link>
                  /
                  <Link to={`/store${redirectTo}`}>
                    <span className="active">{header1}</span>
                  </Link>
                  /<span className="item__name">{content.productName}</span>
                </div>
                <div className="item__wrapper">
                  <div className="panel1">
                    <div className="row">
                      <div className="col-md-4" style={{ textAlign: "center" }}>
                        <div className="product__img">
                          <div className="slider__content">
                            <Slider {...settings2}>
                              {content.imgUrls.map((item, i) => {
                                return (
                                  <div key={i} className="slider__img">
                                    <img
                                      src={item}
                                      alt={content.detailName}
                                      className="img img-responsive"
                                    />
                                  </div>
                                );
                              })}
                            </Slider>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <h2 className="product__name">
                            {content.detailName}
                          </h2>
                          <div className="product__nameHindi">
                            {content.hindiName !== ""
                              ? `( ${content.hindiName} )`
                              : null}
                          </div>
                        </div>
                        <div className="row">
                          <div className="sub__heading">
                            <span>Description</span>
                          </div>
                          <div className="product__desc">{content.desc}</div>
                        </div>
                        <div className="row">
                          <div className="col-md-2">
                            <div className="text-grey">Price</div>
                            <div className="mrp">
                              <i className="fa fa-inr" aria-hidden="true" />{" "}
                              {content.mrp}
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="text-grey">Weight</div>
                            <div className="mrp">{content.netWeight}</div>
                          </div>
                        </div>
                        <RestrictedStateWiseComponent regionName={region}>
                          <div className="row">
                            <div className="col-xs-5">
                              <div className="input-group qty">
                                <span className="input-group-btn">
                                  <button
                                    onClick={() => this.handleQuantity("sub")}
                                    type="button"
                                    className="quantity-left-minus btn btn-default btn-number"
                                    data-type="minus"
                                    data-field=""
                                  >
                                    <span className="glyphicon glyphicon-minus" />
                                  </button>
                                </span>
                                <input
                                  readOnly
                                  type="text"
                                  id="quantity"
                                  name="quantity"
                                  className="form-control input-number"
                                  value={qty || 1}
                                  min="1"
                                  max="100"
                                />
                                <span className="input-group-btn">
                                  <button
                                    onClick={() => this.handleQuantity("add")}
                                    type="button"
                                    className="quantity-right-plus btn btn-default btn-number"
                                    data-type="plus"
                                    data-field=""
                                  >
                                    <span className="glyphicon glyphicon-plus" />
                                  </button>
                                </span>
                              </div>
                            </div>
                            <div className="col-xs-7">
                              <div className="product__Add_to_cart">
                                {qty > 0 && added ? (
                                  <Button>Added</Button>
                                ) : (
                                  <Button
                                    onClick={() => this.addToCart(content)}
                                  >
                                    Add To Cart
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>
                        </RestrictedStateWiseComponent>
                        <div className="sub__heading">
                          <span>Ingredients</span>
                        </div>
                        <div className="product__desc">
                          {content.ingredients.map((item, i) => {
                            return (
                              <ul key={i}>
                                <li>{item}</li>
                              </ul>
                            );
                          })}
                        </div>
                        <div className="product__reci">
                          {content.recipesId.length ? (
                            <div>
                              <Button
                                onClick={this.onChangeRecipe}
                                className="recipe__btn"
                              >
                                Recipes{" "}
                                <i
                                  className={`fa fa-chevron-${
                                    showDropdown ? "up" : "down"
                                  }`}
                                />
                              </Button>
                              <div
                                className="reci__dropdown"
                                style={
                                  showDropdown
                                    ? { display: "block" }
                                    : { display: "none" }
                                }
                              >
                                {content.recipesId.length ? (
                                  content.recipesId.map((id) => {
                                    if (recipes[id].isActive) {
                                      return (
                                        <Link
                                          to={`/recipes/${recipes[
                                            id
                                          ].title.replace(/ /g, "")}`}
                                          key={id}
                                        >
                                          <span className="reci__title">
                                            {recipes[id].title}
                                          </span>
                                        </Link>
                                      );
                                    } else return null;
                                  })
                                ) : (
                                  <div className="no_recipe">
                                    No Recipe found from this Ingredients
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="panel2">
                    <div className="row">
                      <div className="slider__content">
                        <div className="desktop">
                          <Slider {...settingsForDesktop}>
                            {sliderList.map((item) => {
                              return (
                                <a
                                  key={item.title}
                                  href={`/products/Detail?${
                                    item.type
                                  }&${item.urlName.replace(/ /g, "-")}`}
                                >
                                  <div key={item.title}>
                                    <div className="slider__img">
                                      <img
                                        src={item.imgSrc}
                                        alt={item.title}
                                        className="img img-responsive"
                                      />
                                    </div>
                                    <div className="slider__title product__below__title">
                                      {item.productName}
                                    </div>
                                  </div>
                                </a>
                              );
                            })}
                          </Slider>
                        </div>
                        <div className="mobile">
                          <Slider {...settingsPanel2}>
                            {sliderList.map((item) => {
                              return (
                                <a
                                  key={item.title}
                                  href={`/products/Detail?${
                                    item.type
                                  }&${item.urlName.replace(/ /g, "-")}`}
                                >
                                  <div key={item.title}>
                                    <div className="slider__img">
                                      <img
                                        src={item.imgSrc}
                                        alt={item.title}
                                        className="img img-responsive"
                                      />
                                    </div>
                                    <div className="slider__title">
                                      {item.productName}
                                    </div>
                                  </div>
                                </a>
                              );
                            })}
                          </Slider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              height: "80vh",
              width: "20%",
              margin: "20vh auto",
              textAlign: "center",
            }}
          >
            <i className="fa fa-spin fa-spinner" />
          </div>
        )}
      </ContentPage>
    );
  }
}

DetailView.propTypes = {
  header1: PropTypes.string,
  header2: PropTypes.string,
  region: PropTypes.string,
  contentPromise: PropTypes.object,
  location: PropTypes.object,
};

const mapDispatchToPropsView = (dispatch) => {
  return {
    setToCart: (bucket) =>
      dispatch({ type: `SET_TO_CART`, addToCartList: bucket }),
  };
};

const mapStateToProps = (state, ownProps) => {
  // const { params } = ownProps
  const { location } = ownProps;
  let searchString = "";
  // console.log(window.location)
  searchString = (location.search.split("?")[1] || "").split("&");
  // console.log(location.search.split("/"))
  const type = searchString[0] || null;
  const title = searchString[1] || null;
  // console.log("type", type, title)
  let contentData = {};
  let contentPromise = new Promise((resolve, reject) => {
    let content = {};
    if (type === "Spices" && title) {
      SpiceDetails.forEach((item) => {
        if (title === item.urlName.replace(/ /g, "-")) {
          content = state.addToCartList.products[item.id] || item;
        }
      });
    } else if (type === "Dhoop" && title) {
      DhoopDetails.forEach((item) => {
        if (title === item.urlName.replace(/ /g, "-")) {
          content = state.addToCartList.products[item.id] || item;
        }
      });
    } else if (type === "Misc" && title) {
      Misc.forEach((item) => {
        if (title === item.urlName.replace(/ /g, "-")) {
          content = state.addToCartList.products[item.id] || item;
        }
      });
    } else {
      content = {};
    }
    return resolve(content);
  });
  // content1.then(item => console.log(item))
  // console.log("content", contentData)
  return {
    ...ownProps,
    contentPromise: contentPromise,
    header1: type,
    header2: title,
    isAddToCartChange: state.addToCartList.isAddToCartChange,
    region: state.ipData.region || "delhi",
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToPropsView
)(DetailView);



// WEBPACK FOOTER //
// ./src/pages/products/Detail/index.js